// ---------------------------------------------------------------------------
// Cloudflare Images variant URL helpers
//
// The implementation moved to `@utils/core` (Sep 2026) so the dashboard and
// the staff portal — which cannot import this React package — resolve variants
// the same way the templates do. This module stays as the import path the
// template tree already uses.
//
// Behaviour note: the helpers now leave non-Cloudflare urls untouched. The
// previous "swap everything after the last slash" version mangled Stream
// manifests and the editor's `data:image/svg+xml,…` sample media into
// `data:image/public`. See `@utils/core`'s `mediaVariants` for the details.
// ---------------------------------------------------------------------------

export { getPublicSrc, getLargeSrc, getSmallSrc } from "@utils/core";
